import actions from './prevent-lock-screen.actions'
import getters from './prevent-lock-screen.getters'

export default {
  namespaced: true,
  actions,
  getters,
}
